import { combineReducers } from 'redux';
import auth from './auth/slice';
import modal from './modal/slice';
// import here
import platforms from './platforms/slice';
import niches from './niches/slice';
import comments from './comments/slice';
import notifications from './notifications/slice';
import reference from './referenceData/slice';
import config from './config/slice';
import orders from './orders/slice';

export default () =>
  combineReducers({
    auth,
    modal,
    config,
    reference,
    // add reducer here
    platforms,
    niches,
    comments,
    notifications,
    orders,
  });
